export function mergePatch(previous = {}, next = {}) {
  const cells = new Map((previous.upsertCells || []).map(cell => [cell.cellId, cell]));
  const removed = new Set(previous.removeCellIds || []);
  for (const id of next.removeCellIds || []) { cells.delete(id); removed.add(id); }
  for (const cell of next.upsertCells || []) { cells.set(cell.cellId, cell); removed.delete(cell.cellId); }
  return { draft: { ...previous.draft, ...next.draft }, upsertCells: [...cells.values()], removeCellIds: [...removed] };
}
export function applyPatch(draft, patch = {}) {
  const cells = new Map((draft?.cells || []).map(cell => [cell.cellId, cell]));
  for (const id of patch.removeCellIds || []) cells.delete(id);
  for (const cell of patch.upsertCells || []) cells.set(cell.cellId, cell);
  return { ...draft, ...patch.draft, cells: [...cells.values()] };
}
export function mutationBody(identity, patch, requestId) {
  const body = { ...identity, ...patch, requestId };
  if (new Blob([JSON.stringify(body)]).size > 512 * 1024) throw new Error('O rascunho excede o limite de envio. Salve em etapas menores.');
  return body;
}
export function splitDraftPatch(patch, workingDraft, identity = {}) {
  const batches = [], removed = new Set(patch.removeCellIds || []);
  if (patch.draft?.scopes && workingDraft) {
    const remaining = new Set(patch.draft.scopes.map(scope => scope.costScopeId));
    for (const cell of workingDraft.cells || []) if (!remaining.has(cell.costScopeId)) removed.add(cell.cellId);
  }
  const chunks = (items, field) => {
    const overhead = new Blob([JSON.stringify({...identity,expectedRevision:Number.MAX_SAFE_INTEGER,requestId:'0'.repeat(64),[field]:[]})]).size;
    let group=[],bytes=overhead;
    for(const item of items){
      const size=new Blob([JSON.stringify(item)]).size;
      if(group.length && bytes+size+1>512*1024){batches.push({[field]:group});group=[];bytes=overhead;}
      bytes+=size+(group.length?1:0);group.push(item);
    }
    if(group.length)batches.push({[field]:group});
  };
  // Delete orphaned cells while the old scopes still exist; then replace metadata,
  // then upsert the new cells. Every step is an independently versioned draft save.
  chunks([...removed], 'removeCellIds');
  if (patch.draft && Object.keys(patch.draft).length) batches.push({draft:patch.draft});
  chunks(patch.upsertCells || [], 'upsertCells');
  return batches;
}
export function draftDelta(confirmed, working) {
  const draft={};
  for(const field of ['sourceKind','basis','currency','title','period','scopes']) {
    if(JSON.stringify(confirmed?.[field])!==JSON.stringify(working[field]))draft[field]=working[field];
  }
  const before=new Map((confirmed?.cells??[]).map(cell=>[cell.cellId,cell]));
  const scopes=new Set((working.scopes??[]).map(scope=>scope.costScopeId));
  const after=new Map((working.cells??[]).filter(cell=>scopes.has(cell.costScopeId)).map(cell=>[cell.cellId,cell]));
  return {draft,upsertCells:[...after.values()].filter(cell=>JSON.stringify(before.get(cell.cellId))!==JSON.stringify(cell)),removeCellIds:[...before.keys()].filter(id=>!after.has(id))};
}
export function requestGate() {
  let sequence = 0;
  return { next: key => ({key, sequence: ++sequence}), current: ticket => ticket.sequence === sequence, cancel: () => { sequence += 1; } };
}
export const newRequestId = () => globalThis.crypto?.randomUUID?.() || `cost-plan-${Date.now()}-${Math.random().toString(36).slice(2)}`;
